module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_14.a8bf0362.svg";